import React from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';
import { Dialog, DialogContent, DialogContentText } from '@material-ui/core';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

export default function PopupModal(props) {
  const { isOpen, handleClose, title, severity, content, buttonGroup } = props;

  const closeDialog = (event, reason) => {
    if (reason !== 'backdropClick') {
      handleClose();
    }
  };

  return (
    <>
      <Dialog open={isOpen} onClose={closeDialog}>
        <Alert severity={severity}>
          <AlertTitle>{title}</AlertTitle>
        </Alert>
        <DialogContent>
          <DialogContentText>{content}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <DialogActions>
            {buttonGroup.map(button => {
              return <Button onClick={button.action}>{button.title}</Button>;
            })}
          </DialogActions>
        </DialogActions>
      </Dialog>
    </>
  );
}
